import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import SignUpWithPhoneUI from './SignUpWithPhoneUI.js'

class SignUpWithPhoneSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: [],
      submitted: false,
      // countryCode
      countryCode: this.props.context.session.countryCode,
      countryCodeError: null,
      countryList: null,
    }
  }

  render() {
    return (
      <SignUpWithPhoneUI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // phoneNumber
        phoneNumber={this.props.phoneNumber}
        onPhoneNumberChange={this.props.onPhoneNumberChange}
        phoneNumberError={this.props.phoneNumberError}
        setPhoneNumberError={this.props.setPhoneNumberError}
        // countryCode
        countryCode={this.state.countryCode}
        onCountryCodeChange={this.onCountryCodeChange}
        countryCodeError={this.state.countryCodeError}
        setCountryCodeError={(error) => {this.setState({countryCodeError: error})}}
        countryList={this.state.countryList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCountries(context)
    this.getMessages(context)
  }

  onCountryCodeChange = (event) => {
    this.setState({countryCode: event.target.value})
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/pub/signUpWithPhone`,
      this.onSignUpCallback, {
        phoneNumber: this.props.phoneNumber,
        countryCode: this.state.countryCode,
      }
    )
  }

  onSignUpCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'phoneNumber':
            this.props.setPhoneNumberError(error.message)
            break;
          case 'countryCode':
            this.setState({countryCodeError: error.message})
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({
      successMsg: response.success,
      submitted: false
    })

    if (errorList.length === 0) {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
      this.props.setView('verification')
    }
  }

  getCountries(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/countries`,
      cacheKey: CacheKeys.Countries(),
      callback: this.getCountriesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.props.context)
  }

  getCountriesCallback = (response) => {
    let countryList = response.countryList.map(country => ({key: country.code, value: country.name}))
    this.setState({countryList: countryList})
  }

  getMessages(context) {
    let arr = [
      'c_phone_number',
      'c_country',
      'c_sign_up',
      'c_tip_verify_phone',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pub_signup_w_ph_num', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default SignUpWithPhoneSF
